module.exports = __webpack_public_path__ + "static/img/46-2.2b482b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/46-2.jpg
// module id = TXOz
// module chunks = 0